import { styled } from 'styled-components';


export const StageWorkflowStyled = styled.div`
	overflow-x: auto;
	width: 100%;
	position: relative;

	.reils {
		display: flex;
		gap: 16px;
		padding-bottom: 20px;
		padding-top: 16px;
		position: relative;
		width: 1700px;
	}

	&::-webkit-scrollbar {
		border-radius: 10px;
		width: 4px;
		height: 4px;
	}

	&::-webkit-scrollbar-track {
		background-color: #0b93e330;
		margin: 4px 0;
		border-radius: 10px;
	}

	&::-webkit-scrollbar-thumb {
		background-color: #0b93e3;
		border-radius: 8px;
	}

	.ea-stage-step.active .ea-stage-step__title {
		color: #0b93e3;
	}

	.ea-stage-step.active .ea-stage-step__index {
		border-color: #09b910;
		background: #09b910;
		color: #fff;
	}

	.ea-stage-step.rejected .ea-stage-step__title {
		color: #e32b0b;
	}

	.ea-stage-step.rejected .ea-stage-step__index {
		border-color: #e32b0b;
		background: #e32b0b;
		color: #fff;
	}

	.ea-stage-step.active.lastActive .ea-stage-step__index {
		border-color: #0b93e3;
		background: #0b93e3;
		color: #fff;
	}

	.ea-stage-step.forceActive .ea-stage-step__index {
		border-color: #09b910 !important;
		background: #09b910 !important;
		color: #fff;
	}

	span.dashed {
		position: absolute;
		height: 2px;
		width: calc(100% - 130px);
		left: 10px;
		top: 31px;
		border-top: 2px dashed #dae4e8;
	}

	.ea-stage-step {
		width: 140px;
		flex-shrink: 0;
		min-height: 40px;
		z-index: 2;

		&.active:not(.lastActive) {
			position: relative;

			&:after {
				content: '';
				position: absolute;
				top: 15px;
				left: 0;
				width: calc(100% + 20px);
				height: 2px;
				background: #09b910;
				z-index: 1;
			}
		}

		&__index {
			width: 32px;
			height: 32px;
			border-radius: 50%;
			display: flex;
			align-items: center;
			justify-content: center;
			line-height: 1;
			background: #fff;
			border: 1px solid #dae4e8;
			font-size: 14px;
			font-weight: 500;
			position: relative;
			z-index: 3;
		}

		&__title {
			font-size: 13px;
			font-weight: 600;
			line-height: 1.5;
			letter-spacing: -2%;
			margin-top: 17px;
		}

		&__responsible {
			margin-top: 5px;
			font-size: 13px;
			line-height: 1.5;
			color: #525259;

			span {
				font-weight: 500;
				font-size: 10px;
				text-transform: uppercase;
				color: #abb3bb;
			}
		}

		&__more {
			margin-top: 13px;
			font-size: 13px;
			line-height: 1.5;
			font-weight: 600;
			text-decoration: underline;
			background: none;
			color: #0b93e3;

			&:hover {
				text-decoration: none;
			}
		}
	}
`;
